import { createGetFetch } from '../../lib/createFetch.js';
import { GetSimilarPurchasesRes } from '../../pages/api/purchases/similarPurchases.js';
import { GetSimilarPurchasesReq } from '../../pages/api/purchases/similarPurchases.js';

export const getSimilarPurchases = createGetFetch<
  GetSimilarPurchasesReq,
  GetSimilarPurchasesRes
>('/api/purchases/similarPurchases');
